import {
  Dialog,
  DialogContent,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TextLines from '../../../../../components/vizzle/text/TextLines';
import './ActivityInstructionDialog.scss';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  id: null,
  instructions: {},
  open: false,
  onClose: () => {},
  audioPlaying: false,
};

export default function ActivityInstructionDialog(p) {
  const {
    id,
    instructions,
    open,
    onClose,
    audioPlaying,
  } = { ...defaultProps, ...filterUndefined({ ...p }) };
  return open ? (
    <Dialog open={open} data-test='activity-instruction-dialog' className={`activity-instruction-dialog ${audioPlaying ? 'activity-instruction-dialog-with-audio' : ''}`}>
      <IconButton
        aria-label='close instructions'
        className='close-button'
        onClick={onClose}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.stopPropagation();
            event.preventDefault();
            onClose();
          }
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent className='content'>
        {
          instructions.text ? <TextLines componentKey={id} textLines={instructions.text} /> : ''
        }
      </DialogContent>
    </Dialog>
  ) : null;
}
